/* eslint-disable prettier/prettier */
import { useEffect, useState, useCallback } from 'react'

import { Link } from 'react-router-dom'

import { initFlowbite } from 'flowbite'

import { dealsService } from 'services'

import { Pagination } from 'components'
import Skeleton from 'components/skeleton'
import AddNewDealModal from 'components/modal/add-deal'

import { routes } from 'utils/routes'
import { dateFormat } from 'utils'
import { _object } from 'utils/interfaces'

import { DeleteIcon, EditIcon, ViewIcon } from 'assets/svg'
import { Placeholder } from 'assets/images'
import { useDispatch, useSelector } from 'react-redux'
import { setDealFilterData } from '../redux/slices/filter.slice'

const Deals = () => {
  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<_object>({})
  const dispatch = useDispatch()
  const savedFilters = useSelector((state: _object) => state.filter.dealFilter)

  const [filters, setFilters] = useState(
    Object.keys(savedFilters || {}).length ? savedFilters : {
      q: '',
      page: 1,
      per_page: 25,
      sort: '',
      filters: { status: '' }
    }
  )

  useEffect(() => {
    initFlowbite()
  }, [])

  const getDeal = useCallback(() => {
    dealsService.getDeals(filters).then((results) => {
      setResults(results)
      setLoading(false)
    })
  }, [filters])

  useEffect(() => {
    getDeal()
    setLoading(true)
  }, [getDeal])

  useEffect(() => {
    dispatch(setDealFilterData(filters))
  }, [dispatch, filters])


  const deleteBrand = (id: string) => {
    if (window.confirm('Are you sure you want to delete?')) {
      dealsService.deleteDeal(id).then(() => {
        getDeal()
      })
    }
  }

  return (
    <>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">
          Deals <small>Total records: {results?.pagination?.total_items}</small>
        </h1>
        <button
          className="rounded-md border border-purple-900 bg-purple-900 hover:bg-purple-950 px-4 py-2 text-sm text-white font-medium"
          data-modal-target="add-new-deal"
          data-modal-toggle="add-new-deal"
          type="button"
        >
          Add Deal
        </button>

        {/* <Link
          to={`${routes.deals}/add`}
          className="rounded-md border border-purple-900 bg-purple-900 px-4 py-2 text-sm text-white"
        >
          Add New Deal
        </Link> */}
        {/* </button> */}
      </div>

      <div className="mb-4 flex gap-4">
        <form>
          <div className="flex items-center gap-2">
            <input
              type="search"
              placeholder="Search keyword"
              className="w-60 rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
              value={filters.q || ''}
              onChange={(e) => {
                setFilters({ ...filters, q: e.target.value })
              }}
            />

            <div className="relative w-full">
              <select
                name="status"
                value={filters.filters.status || ''}
                onChange={(e) =>
                  setFilters((prev: _object) => ({
                    ...prev,
                    filters: {
                      ...prev.filters,
                      status: e.target.value
                    }
                  }))
                }
                className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
              >
                <option value="">All status</option>
                {[
                  { key: 'Active', value: 'active' },
                  { key: 'Inactive', value: 'inactive' }
                ].map((item: _object, i: number) => (
                  <option key={i} value={item.value}>
                    {item.key}
                  </option>
                ))}
              </select>

              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>

            <button
              type="button"
              className="px-3 py-1 text-sm font-medium whitespace-nowrap text-red-600 underline"
              onClick={() =>
                setFilters({
                  q: '',
                  page: 1,
                  per_page: 25,
                  sort: '',
                  filters: {
                    status: ''
                  }
                })
              }
            >
              Clear filters
            </button>
          </div>
        </form>
      </div>

      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Deals Offer</th>
              <th className="px-4 py-3 font-semibold">Start Date</th>
              <th className="px-4 py-3 font-semibold">End Date</th>
              <th className="px-4 py-3 font-semibold">Products</th>
              <th className="px-4 py-3 font-semibold">Status</th>
              <th className="py-3">
                <p className="ms-4 text-sm font-semibold text-gray-900">Image</p>
                <span className='text-[10px] text-[#969494] font-medium'>227W × 170H | 5:4{' '}</span>
              </th>

              <th className="px-4 py-3 text-center font-semibold">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.map((item: _object, i: number) => (
                <tr className="hover:bg-gray-50" key={i}>
                  <td className="px-4 py-3">{(filters.page - 1) * filters.per_page + i + 1}</td>
                  <td className="px-4 py-3">{item?.name}</td>
                  <td className="px-4 py-3">
                    {`Buy ${item?.purchase_qty} get ${item?.reward_qty}`}
                  </td>
                  <td className="px-4 py-3">{dateFormat(item?.start_date)}</td>
                  <td className="px-4 py-3">{dateFormat(item?.end_date)}</td>
                  <td className="px-4 py-3">{item?.product_ids?.length}</td>
                  <td className="px-4 py-3">{item?.status}</td>
                  <td className="px-4 py-3">
                    <div className="h-[50px] w-[50px]">
                      <img
                        src={item?.image || Placeholder}
                        alt={item.name}
                        className="rounded-md h-full w-full object-cover"
                      />
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex h-full items-center justify-end gap-2">
                      <Link
                        to={`https://treasuresunlimited.vercel.app/deals/${item.id}`}
                        target="blank"
                        title="View Deal"
                      >
                        <ViewIcon className="h-[20px] w-[20px]" />
                      </Link>
                      <Link to={`${routes.deals}/${item.id}`} title="Edit Deal">
                        <EditIcon />
                      </Link>
                      <button
                        type="button"
                        onClick={() => deleteBrand(item.id)}
                        title="Delete Deal"
                      >
                        <DeleteIcon className="h-[20px] w-[20px]" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <Skeleton />
            )}
            {results?.items?.length <= 0 &&
              <td colSpan={12} className="text-center py-6 text-gray-500">
                <p>No record found</p>
              </td>
            }
          </tbody>
        </table>
      </div>

      {results?.pagination?.total_pages > 1 && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}
      <AddNewDealModal />
    </>
  )
}
export default Deals
